import Default from "./VariableStatusIcon";
export * from "./VariableStatusIcon";

export default Default;
